import React, { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { Suspense, lazy } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Crmroutes } from "./Routes";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "./components/Auth/Config/Config";
import LocationCheck from "./components/Location/Location";
import Loading from "./Loading/Loading";
import GoogleMap from "./components/Auth/Config/GoogleMaps";
import ToastProvider from "./components/Toast/Toast";
import Message from "./components/Auth/Message/Message";
import { SearchProvider } from "./components/Search/SearchProvider";

const Home = lazy(() => import("./components/Home/Home"));
const Login = lazy(() => import("./components/Auth/Login"));
const View = lazy(() => import("./components/View/View"));
const Add = lazy(() => import("./components/ADD ITEM/Add"));
const Messege = lazy(() => import("./components/Messege/Messege"));
const Profile = lazy(() => import("./components/Profile/Profile"));
const Toast = lazy(() => import("./components/Toast/Toast"));
const AllMessage = lazy(() => import("./components/Messege/AllMessage"));
const Blankmessege = lazy(() => import("./components/Messege/Blankmessege"));
const SearchPage = lazy(() => import("./components/Search/SearchPage"));
const Featured = lazy(() => import("./components/Featured/Featured"));
const MustHaves = lazy(() => import("./components/Must-Haves/MustHaves"));
const MobileVerification = lazy(() => import("./components/Auth/MobileVerification"));
const Termsandcondition = lazy(() => import("./components/Profile/Termsandcondition"));
const Consultancy = lazy(() => import("./components/Consultancy/Consultancy"));
const ManagementConsultancy = lazy(() => import("./components/Consultancy/ManagementConsultancy"));
const RealEstateConsultancy = lazy(() => import("./components/Consultancy/RealEstateConsultancy"));
const FinancialConsultancy = lazy(() => import("./components/Consultancy/FinancialConsultancy"));
const About = lazy(() => import("./components/About/About"));
const Contact = lazy(() => import("./components/Contact/Contact"));
const Blog = lazy(() => import("./components/Blog/Blog"));
const Article = lazy(() => import("./components/Blog/Article"));
const ResidentialLeasing = lazy(() => import("./components/Inventory/ResidentialLeasing"));
const ResidentialSale = lazy(() => import("./components/Inventory/ResidentialSale"));
const CommercialLeasing = lazy(() => import("./components/Inventory/CommercialLeasing"));
const CommercialSale = lazy(() => import("./components/Inventory/CommercialSale"));
const HotelsLeasing = lazy(() => import("./components/Inventory/HotelsLeasing"));
const HotelsSale = lazy(() => import("./components/Inventory/HotelsSale"));
const CommercialEntitiesSale = lazy(() => import("./components/Inventory/CommercialEntitiesSale"));
const LandSale = lazy(() => import("./components/Inventory/LandSale"));
const LandLeasing = lazy(() => import("./components/Inventory/LandLeasing"));
const MiscellaneousInventory = lazy(() => import("./components/Inventory/MiscellaneousInventory"));

const App = () => {

  LocationCheck();
  const [userDetails, setuserDetails] = useState();
  const [loading, setloading] = useState(true);
  const auth = getAuth();
  const location = useLocation()


  useEffect(() => {
    const minLoadTime = new Promise(resolve => setTimeout(resolve, 1500));
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        onSnapshot(
          doc(db, "users", user.uid),
          async (snapshot) => {
            setuserDetails(snapshot.data());
            const jsonString = JSON.stringify(snapshot.data());
            localStorage.setItem("userData", jsonString);
            await minLoadTime;
            setloading(false);
          },
          (error) => {
            console.error("Error fetching document:", error);
            minLoadTime.then(() => setloading(false));
          }
        );
      } else {
        setuserDetails(false);
        minLoadTime.then(() => setloading(false));
      }
    });
    return () => unsubscribe();
  }, [auth]);


  return (
    <AnimatePresence mode="wait">
      {loading ? (
        <motion.div
          key="loading-screen"
          className="fixed inset-0 z-[9999]"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
        >
          <Loading />
        </motion.div>
      ) : (
        <motion.div
          key="main-app"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
        >
          <ToastProvider>
            <Message>
              <SearchProvider>
                <GoogleMap />
                {location.pathname === "/product-terms-conditions" ? null : (
                  <Navbar user={userDetails} loading={loading} />
                )}

                <Suspense fallback={<div className="w-full h-[60vh] flex items-center justify-center"><div className="w-10 h-10 border-4 border-cyan-500/30 border-t-cyan-500 rounded-full animate-spin"></div></div>}>
                  <Routes>
                    <Route index element={<Home user={userDetails} />} />
                    <Route
                      path={Crmroutes.Login.path}
                      index
                      element={<Login />}
                    />
                    <Route path={Crmroutes.ProductView.path} element={<View />} />
                    <Route path={Crmroutes.AddProduct.path} element={<Add />} />
                    <Route path={Crmroutes.Message.path} element={<Messege />} />
                    <Route
                      path={Crmroutes.AllMessage.path}
                      element={<AllMessage />}
                    />

                    <Route
                      path={"/search-items"}
                      element={<SearchPage user={userDetails} />}
                    />
                    <Route path={"/featured-items"} element={<Featured />} />
                    <Route path={"/must-haves"} element={<MustHaves />} />

                    <Route
                      path={Crmroutes.Profile.path}
                      index
                      element={<Profile user={userDetails} />}
                    />
                    <Route path="/to" index element={<Toast />} />
                    <Route path="/bla" index element={<Blankmessege />} />
                    <Route path="/sea" index element={<SearchPage />} />
                    <Route path="/con" index element={<Consultancy />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route
                      path="/services/management-consultancy"
                      element={<ManagementConsultancy />}
                    />
                    <Route
                      path="/services/real-estate-consultancy"
                      element={<RealEstateConsultancy />}
                    />
                    <Route
                      path="/services/financial-consultancy"
                      element={<FinancialConsultancy />}
                    />
                    <Route
                      path="/product-terms-conditions"
                      index
                      element={<Termsandcondition />}
                    />
                    <Route path='/blog' element={<Blog />} />
                    <Route path='/blog/article/:id' element={<Article />} />

                    {/* Real Estate Inventory Routes */}
                    <Route path={Crmroutes.ResidentialLeasing.path} element={<ResidentialLeasing />} />
                    <Route path={Crmroutes.ResidentialSale.path} element={<ResidentialSale />} />
                    <Route path={Crmroutes.CommercialLeasing.path} element={<CommercialLeasing />} />
                    <Route path={Crmroutes.CommercialSale.path} element={<CommercialSale />} />
                    <Route path={Crmroutes.HotelsLeasing.path} element={<HotelsLeasing />} />
                    <Route path={Crmroutes.HotelsSale.path} element={<HotelsSale />} />
                    <Route path={Crmroutes.CommercialEntitiesSale.path} element={<CommercialEntitiesSale />} />
                    <Route path={Crmroutes.LandSale.path} element={<LandSale />} />
                    <Route path={Crmroutes.LandLeasing.path} element={<LandLeasing />} />
                    <Route path={Crmroutes.MiscellaneousInventory.path} element={<MiscellaneousInventory />} />
                  </Routes>

                  <Login />
                  <MobileVerification />
                  <Add />
                  <Footer />
                </Suspense>
              </SearchProvider>
            </Message>
          </ToastProvider>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default App;
